import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";

import { Grid, Paper } from "@material-ui/core";
import { InputOptionMaster, MasterButton } from "App/Component/ui";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
}));

export default function TabPerusahaan() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'>
          <div className='fw-600'>BPJS</div>
          <MasterButton name='Edit' color={"secondary"} size='md' />
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={4}>
            <div className='mt-1'>
              <InputOptionMaster
                name='jenis'
                label='JENIS HARGA'
                id='jenis'
                disabled={true}
                data={[
                  {
                    value: "umum",
                    label: "Umum",
                  },
                ]}
              />
            </div>
          </Grid>
        </Grid>
      </Paper>

      <div className='mt-2'>
        <Paper className={classes.paper}>
          <Grid
            container
            direction='row'
            justifyContent='space-between'
            alignItems='center'>
            <div className='fw-600'>UMUM</div>
            <MasterButton name='Edit' color={"secondary"} size='md' />
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={6} sm={4}>
              <div className='mt-1'>
                <InputOptionMaster
                  name='jenis'
                  label='JENIS HARGA'
                  id='jenis'
                  disabled={true}
                  data={[
                    {
                      value: "umum",
                      label: "Umum",
                    },
                  ]}
                />
              </div>
            </Grid>
          </Grid>
        </Paper>
      </div>
    </div>
  );
}
